import React from 'react';
import Banner from '../Banner/Banner';
import HomeAbout from '../HomeAbout/HomeAbout';
import Footer from '../../Shared/Footer/Footer';
import MyServices from '../MyServices/MyServices';
import Skills from '../Skills/Skills';
import HomeResume from '../HomeResume/HomeResume';
import HomeProjects from '../HomeProjects/HomeProjects';
import HomeBlogs from '../HomeBlogs/HomeBlogs/HomeBlogs';


const Home = () => {
    
return (
    <div>
        <Banner />
        <HomeAbout />
        <MyServices />
        <Skills />
        <HomeResume />
        <HomeProjects />
        <HomeBlogs />
        <Footer />
    </div>

                                       
    );
};

export default Home;